import { Fragment } from "react";
import styled, { CSSProperties } from "styled-components";

import Divider from "@vfuk/core-divider";
import Spacing from "@vfuk/core-spacing";

import { IconLink, type IconLinkProps } from "../IconLink";
import { Stack } from "../Stack";
import { Tooltip } from "../Tooltip";

// As recommended by Source Web (see "Divider" component)
const DividerHeight = styled.div`
  height: 45px;
`;

interface TableAction extends IconLinkProps {
  shouldRender?: boolean;
  disabledTooltipText?: string;
}

interface TableActionButtonsProps {
  actions: TableAction[];
  justifyContent?: CSSProperties["justifyContent"];
}

export const TableActionButtons = ({
  actions,
  justifyContent,
}: TableActionButtonsProps) => (
  <Stack justifyContent={justifyContent}>
    {actions
      // Only render actions that have shouldRender either undefined or true
      .filter((action) => action.shouldRender !== false)
      .map((action, index) => (
        <Fragment key={index}>
          <Tooltip
            disabled={!action.isDisabled}
            content={action.disabledTooltipText}
          >
            <span>
              <Spacing spacingLevel={index === 0 ? { right: 3 } : { left: 3 }}>
                <IconLink key={action.text} {...action} />
              </Spacing>
            </span>
          </Tooltip>
          {action !== actions.at(-1) && (
            <DividerHeight>
              <Divider appearance="secondary" orientation="vertical" />
            </DividerHeight>
          )}
        </Fragment>
      ))}
  </Stack>
);
